<script>
  import Button from '@components/buttons/button.svelte'
  import { setParam } from '@lib/utils'

  let { 
    pagination = { summary: null, previous: null, next: null },
    paginationProps = {},
  } = $props()

  let defaultPaginationProps = { summary: false, terms: ["item", "items"] }
  let derivedPaginationProps = $derived(Object.assign({}, defaultPaginationProps, paginationProps))

  let summary = $derived.by(() => {
    if (!derivedPaginationProps?.summary || !pagination?.summary) return null
    return pagination.summary.replace("items", derivedPaginationProps.terms[1]).replace("item", derivedPaginationProps.terms[0])
  })

  let visible = $derived(pagination?.previous || pagination?.next)

  function previous() { setParam('page', pagination.previous) }
  function next() { setParam('page', pagination.next) }
</script>

{#if visible}
  <div class="flex justify-end items-center gap-3 pt-4 mt-2 border-t border-gray-100">
    {#if summary}
      <p class="text-xs text-gray-400">{summary}</p>
    {/if}
    <div class="flex items-center gap-2">
      <Button size="xs" onclick={previous} disabled={!pagination.previous}>Previous</Button>
      <Button size="xs" onclick={next} disabled={!pagination.next}>Next</Button>
    </div>
  </div>
{/if}
